import React from 'react';
import s from './VerdictPanel.module.css';

const LADDER = [
  {
    tier: 'Tier 0',
    desc: <><strong>Free hooks</strong> — voice cash-log, statement reconciliation. Acquire &amp; build the data moat. Product-led, no sales time.</>,
  },
  {
    tier: 'Tier 1',
    desc: <><strong>Payment wedges</strong> — bulk utility, FASTag, recurring/intent collections. Monetise via commission + subscription.</>,
  },
  {
    tier: 'Tier 2',
    desc: <><strong>Finance-ops SaaS</strong> — reconciliation, vendor payments, cross-border. Subscription; sales-led.</>,
  },
  {
    tier: 'Tier 3',
    desc: <><strong>Enterprise / agentic</strong> — AI reconciliation, financing to banks. Senior BD, long cycle.</>,
  },
];

export default function VerdictPanel({ verdict, style: st, wedge, onCopy, copied }) {
  return (
    <aside className={s.verdict}>
      {/* Main verdict card */}
      <div className={s.panel}>
        <div className={s.vhead}>Verdict</div>

        <div
          className={s.chip}
          style={{ background: st.bg, color: st.c }}
        >
          <span className={s.dot} style={{ background: st.c }} />
          {st.t}
        </div>

        <div className={s.motion}>
          {verdict.motion
            ? <><strong>{verdict.motion}</strong></>
            : <>Fill in <strong>who</strong>, <strong>hooks</strong> and <strong>scale</strong> to get a call.</>}
        </div>
        {verdict.owner && (
          <div className={s.owner}>{verdict.owner}</div>
        )}

        <div className={s.wedge}>
          <div className={s.wl}>Lead with</div>
          <div className={s.wv}>{wedge}</div>
        </div>

        <div className={s.scorewrap}>
          <div className={s.scoretop}>
            <span>Fit score</span>
            <strong>{verdict.score}/100</strong>
          </div>
          <div className={s.bar}>
            <i
              className={s.barFill}
              style={{ width: `${verdict.score}%` }}
            />
          </div>
        </div>

        {verdict.reasons.length > 0 && (
          <ul className={s.reasons}>
            {verdict.reasons.map((r, i) => (
              <li key={i}>{r}</li>
            ))}
          </ul>
        )}

        <button type="button" className={s.copy} onClick={onCopy}>
          {copied ? 'Copied ✓' : 'Copy summary for CRM / Trello'}
        </button>
      </div>

      {/* Product ladder */}
      <div className={`${s.panel} ${s.ladder}`}>
        <div className={s.lh}>The product ladder</div>
        {LADDER.map(rung => (
          <div key={rung.tier} className={s.rung}>
            <span className={s.t}>{rung.tier}</span>
            <span className={s.d}>{rung.desc}</span>
          </div>
        ))}
      </div>
    </aside>
  );
}
